// src/pages/CommissionMaster.jsx
import React, { useState } from 'react';
import '../assets/CommissionMaster.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCogs, faSave } from '@fortawesome/free-solid-svg-icons';

const CommissionMaster = () => {
  const [formData, setFormData] = useState({
    schemeType: '',
    scheme: '',
    commissionType: '',
    commissionMode: '',
    rank: '',
    collectionCharge: '',
  });

  const schemeTypes = [
    { id: '1', name: 'Monthly' },
    { id: '2', name: 'Quarterly' },
  ];

  const schemes = [
    { id: '1', name: 'Plan A' },
    { id: '2', name: 'Plan B' },
  ];

  const commissionTypes = [
    { id: '1', name: 'Flat' },
    { id: '2', name: 'Percentage' },
  ];

  const commissionModes = [
    { id: '1', name: 'Online' },
    { id: '2', name: 'Offline' },
  ];

  const ranks = [
    { id: '1', name: 'Agent' },
    { id: '2', name: 'Manager' },
    { id: '3', name: 'Director' },
  ];

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    // Simulate form submission
    setTimeout(() => {
      alert('Commission rates saved successfully!');
      setFormData({
        schemeType: '',
        scheme: '',
        commissionType: '',
        commissionMode: '',
        rank: '',
        collectionCharge: '',
      });
      setLoading(false);
    }, 1000);
  };

  return (
    <div className="setCommission-container">
      <main className="setCommission-main">
        <section className="setCommission-section gradient-section">
          <h2 className="setCommission-title">
            <FontAwesomeIcon icon={faCogs} /> Set Commission Rates
          </h2>
          <form className="setCommission-form">
            <div className="form-group">
              <label htmlFor="schemeType">Select Scheme Type</label>
              <select id="schemeType" name="schemeType" value={formData.schemeType} onChange={handleChange}>
                <option value="">Select Scheme Type</option>
                {schemeTypes.map((type) => (
                  <option key={type.id} value={type.id}>{type.name}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="scheme">Select Scheme</label>
              <select id="scheme" name="scheme" value={formData.scheme} onChange={handleChange}>
                <option value="">Select Scheme</option>
                {schemes.map((scheme) => (
                  <option key={scheme.id} value={scheme.id}>{scheme.name}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="commissionType">Commission Type</label>
              <select id="commissionType" name="commissionType" value={formData.commissionType} onChange={handleChange}>
                <option value="">Select Commission Type</option>
                {commissionTypes.map((type) => (
                  <option key={type.id} value={type.id}>{type.name}</option>
                ))}
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="commissionMode">Commission Mode</label>
              <select id="commissionMode" name="commissionMode" value={formData.commissionMode} onChange={handleChange}>
                <option value="">Select Commission Mode</option>
                {commissionModes.map((mode) => (
                  <option key={mode.id} value={mode.id}>{mode.name}</option>
                ))}
              </select>
            </div>
          </form>
        </section>

        <section className="setCommission-section gradient-section">
          <select
            className="setCommission-bankSelect"
            size="3"
            name="rank"
            value={formData.rank}
            onChange={handleChange}
          >
            <option disabled>RANK</option>
            {ranks.map((rank) => (
              <option key={rank.id} value={rank.id}>{rank.name}</option>
            ))}
          </select>

          <form className="setCommission-subform" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="collectionCharge">Set Collection Charge</label>
              <input
                type="text"
                id="collectionCharge"
                name="collectionCharge"
                placeholder="Enter collection charge"
                value={formData.collectionCharge}
                onChange={handleChange}
              />
            </div>
            <button type="submit" className="save-button" disabled={loading}>
              <FontAwesomeIcon icon={faSave} /> {loading ? 'Loading...' : 'Save Commission Rates'}
            </button>
          </form>
        </section>
      </main>
    </div>
  );
};

export default CommissionMaster;
